import { useEffect, useRef, useState } from "react";

const DEFAULT_MIN_TABS = 4;
const DEFAULT_TAB_WIDTH = 150;

function useResponsiveTabsPerSlide(totalTabs, options = {}) {
  const { minTabs = DEFAULT_MIN_TABS, approximateTabWidth = DEFAULT_TAB_WIDTH } = options;
  const tabsViewportRef = useRef(null);
  const [tabsPerSlide, setTabsPerSlide] = useState(minTabs);

  useEffect(() => {
    const node = tabsViewportRef.current;
    if (!node) return undefined;

    const updateTabsPerSlide = () => {
      const width = node.getBoundingClientRect().width;
      const nextCount = Math.max(
        minTabs,
        Math.min(totalTabs || minTabs, Math.floor(width / approximateTabWidth))
      );
      setTabsPerSlide(nextCount || minTabs);
    };

    updateTabsPerSlide();

    if (typeof ResizeObserver === "function") {
      const observer = new ResizeObserver(updateTabsPerSlide);
      observer.observe(node);
      return () => observer.disconnect();
    }

    window.addEventListener("resize", updateTabsPerSlide);
    return () => window.removeEventListener("resize", updateTabsPerSlide);
  }, [approximateTabWidth, minTabs, totalTabs]);

  return { tabsViewportRef, tabsPerSlide };
}

export default useResponsiveTabsPerSlide;
